import deepmerge from 'deepmerge';

import main from './main';

const faktum = {
  palette: {
    primary: {
      main: '#C83386'
    },
    secondary: {
      main: '#EEC1DA'
    }
  }
};

export default deepmerge(main, faktum);
